import { Component, Input, ViewChild } from '@angular/core';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { TableDataItem } from '../table.component';
import { ItemOption } from "../item-option";
import { MatMenuTrigger } from "@angular/material/menu";

@Component({
    selector: 'valg-table-row-options',
    templateUrl: './table-row-options.component.html',
    styleUrls: [ './table-row-options.component.scss' ]
})
export class TableRowOptionsComponent<T extends TableDataItem> {

    public SvgIcon = SvgIcon;

    @Input() data!: T;
    @Input() label = "";
    @Input() itemOptions: ItemOption<T>[] = [];
    @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger;

    onClick(option: ItemOption<T>) {
        if (this.matMenuTrigger.menuOpen) {
            this.matMenuTrigger.closeMenu();
        }
        option.action(this.data);
    }

}
